import {PatientOption} from './patient-option';

export class AvailablePatientOptions {

  constructor(
    public options: Array<PatientOption>,
    public noneSelected: boolean,
  ) {
  }

  public toOptionNamesList(): Array<string> {
    return this.options.map((option: PatientOption) => option.name);
  }
}
